import { ResponsiveValue } from '@chakra-ui/react'
import React from 'react'
import IconCallStop from '~/assets/svgs/icon-call-stop.svg?react'
import IconMerge from '~/assets/svgs/icon-merge.svg?react'
import IconPhoneAudio from '~/assets/svgs/icon-phone-audio.svg?react'
import IconPhoneHold from '~/assets/svgs/icon-phone-hold.svg?react'
import IconPhoneKeypad from '~/assets/svgs/icon-phone-keypad.svg?react'
import IconPhoneMute from '~/assets/svgs/icon-phone-mute.svg?react'
import IconPhonePark from '~/assets/svgs/icon-phone-park.svg?react'
import IconPhoneTransfer from '~/assets/svgs/icon-phone-transfer.svg?react'
import IconPlus from '~/assets/svgs/icon-plus.svg?react'
import IconSplit from '~/assets/svgs/icon-split.svg?react'
import { QuickActionButtonVariants } from '~/components/shared/componentStyles/QuickActionButton.style'
import {
  QuickActionButton,
  QuickActionButtonSizes,
} from '~/components/shared/QuickActionButton'

export enum ControlButtonTypes {
  AUDIO = 'AUDIO',
  HOLD = 'HOLD',
  KEYPAD = 'KEYPAD',
  MUTE = 'MUTE',
  PARK = 'PARK',
  TRANSFER = 'TRANSFER',
  NEW = 'NEW',
  MERGE = 'MERGE',
  SPLIT = 'SPLIT',
  END = 'END',
}
const ControlButtonIconConfig = {
  [ControlButtonTypes.AUDIO]: {
    variant: QuickActionButtonVariants.Default_200,
    icon: IconPhoneAudio,
    label: 'Audio Settings',
    styleOverride: {},
  },
  [ControlButtonTypes.HOLD]: {
    variant: QuickActionButtonVariants.Default_200,
    icon: IconPhoneHold,
    label: 'Hold',
    styleOverride: {},
  },
  [ControlButtonTypes.KEYPAD]: {
    variant: QuickActionButtonVariants.Default_200,
    icon: IconPhoneKeypad,
    label: 'Keypad',
    styleOverride: { height: '1.87957rem', width: '1.375rem' },
  },
  [ControlButtonTypes.MUTE]: {
    variant: QuickActionButtonVariants.Default_200,
    icon: IconPhoneMute,
    label: 'Mute',
    styleOverride: {},
  },
  [ControlButtonTypes.PARK]: {
    variant: QuickActionButtonVariants.Default_200,
    icon: IconPhonePark,
    label: 'Park',
    styleOverride: {},
  },
  [ControlButtonTypes.TRANSFER]: {
    variant: QuickActionButtonVariants.Default_200,
    icon: IconPhoneTransfer,
    label: 'Transfer',
    styleOverride: {},
  },
  [ControlButtonTypes.NEW]: {
    variant: QuickActionButtonVariants.Default_200,
    icon: IconPlus,
    label: 'New Call',
    styleOverride: { boxSize: '2rem' },
  },
  [ControlButtonTypes.MERGE]: {
    variant: QuickActionButtonVariants.Default_200,
    icon: IconMerge,
    label: 'Merge Calls',
    styleOverride: { boxSize: '2rem' },
  },
  [ControlButtonTypes.SPLIT]: {
    variant: QuickActionButtonVariants.Default_200,
    icon: IconSplit,
    label: 'Split Conference',
    styleOverride: { boxSize: '2rem' },
  },
  [ControlButtonTypes.END]: {
    variant: QuickActionButtonVariants.Destructive_300,
    icon: IconCallStop,
    label: 'End Call',
    styleOverride: { boxSize: '2rem' },
  },
}

interface ControlButtonProps {
  type: ControlButtonTypes
  size: ResponsiveValue<QuickActionButtonSizes>
  onClick: () => void
  isActive?: boolean
  disabled?: boolean
}
export const CallControlButton = ({
  type,
  size,
  onClick,
  isActive,
  disabled,
}: ControlButtonProps) => {
  const handleClick = () => {
    if (disabled) return
    onClick()
  }

  const { variant, icon, label } = ControlButtonIconConfig[type]

  return (
    <QuickActionButton
      isActive={isActive}
      disabled={disabled}
      variant={variant}
      size={size}
      actionIcon={icon}
      tooltipText={label}
      onClick={handleClick}
      // iconProps={styleOverride}
    />
  )
}
